import { createSlice } from '@reduxjs/toolkit'

export const initialRefDataState = {
  referenceImages: [],
}

export const accountReferenceImagesSlice = createSlice({
  name: 'referenceImages',
  initialState: initialRefDataState,
  reducers: {
    addRefImages(state, action) {
      state.push(action.payload)
    },
  },
})

export const { actions, reducer } = accountReferenceImagesSlice
export default reducer
